import React, { Component } from "react";
// import Hungama from "../Player/Hungamaplayer";
import myplexAPI from "../../api/myplexAPI";
import Youtube from "../Player/Youtubeplayer";
import Bcncontentinfo from "../../projects/Bcncontentinfo";
import Episodes from "./Episodes";
import YOUMAYLIKE from "./Similarcontent";
import Epg from "./Epg";
import SEO from "../../common/helmet";
// import Loader from "../../utils/loader";
import Loader from "../../../commonfiles/loader";
import TvseriesView from "../Player/TvseriesView";
import { isMobile, osName } from "react-device-detect";
import { Link } from "react-router-dom";
// import {slugify} from "../../utils/stringSlugify";
import langBasedPrograms from "../../utils/langBasedPrograms";
import Modalview from "../Player/Modalview";
// import firebase from "../../analytics/firebase"
import PassPlayer from "../Player/PassPlayer";

// import firebaseEvents from "../../common/firebaseEvents";
import lensEvents from "../../LensAnalytics";
// import LayoutSimilarNewsCarousel from "./LayoutSimilarNewsCarousel";
import LayoutTrailersCarousel from "../Slider/LayoutTrailersCarousel";
import Recommended from "./Recommended";
import LayoutCastandCrew from "../Slider/LayoutCastandCrew";
import { Modal, Button } from "react-bootstrap";
// import button_arrow_right from "../../../manorama/assets/images/button_arrow_right.png";
import { genres, redirectPlayStore } from "../../utils/portalhelper";
//import { isIOS } from "react-device-detect";
// import Shaka from "../Player/Shaka";
import Adunit from "../Static/adunit";
import MovieCarosuls from "./MovieCarosuls";
export default class Detail extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.tabName = "";
    this.contentPosition = "";
    this.carouselPosition = "";
    this.tabName = "";
    this.contentSource = "";
    this.sourceName = "";
    this.studioname = "";
    this.state = {
      videolink: "",
      is_youtube: false,
      contentId: null,
      youtubeId: null,
      contentinfo: [],
      similarContent: false,
      similarNews: false,
      is_TVShow: false,
      is_tvepisode: false,
      is_Live: false,
      videoId: null,
      Auth: localStorage.getItem("Logged-in") || false,
      Hungama: false,
      meta_title: "Movies",
      classname: "flow_player",
      new_Title: "",
      new_Description: "",
      _releasedDate: "",
      _createdDate: "",
      _contentUrl: "",
      _contentThumbnail: "",
      episodedata: "",
      movieMarkup: [],
      director: "Not Available",
      description: "",
      _liveDuration: "",
      _liveStartDate: "",
      _liveEndDate: "",
      _contentId: "",
      flag: "false",
      tvShowDetails: [],
      alt_description: false,
      og_url: "",
      appLanguage: localStorage.getItem("selectedAppLanguageList"),
      detailLangList: "",
      meta_description: "",
      popUp: false,
      error: false,
      videoEndedStatus: false,
      showDisplayTabs: [],
      contentTitle: "",
      contentDescription: "",
      recommened: true,
      isTrailerExisted: false,
      seriesId: null,
      seriestags: [],
      show: true,
      keywords: "",
    };
  }

  componentDidMount() {
    if (sessionStorage.getItem(this.props.match.params.Id)) {
      var carosuelDetTab = sessionStorage
        .getItem(this.props.match.params.Id)
        .split("@@");
      if (carosuelDetTab.length > 0) {
        this.carouselPosition = carosuelDetTab[0];
        this.contentPosition = parseInt(carosuelDetTab[1]);

        this.tabName = carosuelDetTab[2];
        this.contentSource = carosuelDetTab[3];
        this.sourceName = carosuelDetTab[4];
      }
    }
    this._isMounted = true;
    this.title_Ref = "";
    this.description_Ref = "";
    // if(this.props.match.params.Id!=="122165" && this.props.match.params.Id!=="122164"){
    this._fetchDetails();
    // }
    this.appLanguageStings();
    // this.pageName = this.props.match.params.PageName;
    // if (this.state.Auth === false) {
    //     document.getElementById("profile_img").click();
    // }

    // const s = document.createElement('script');
    // s.type = 'text/javascript';
   
    // s.innerHTML = "googletag.cmd.push(function() { googletag.display('dfp-ad-lb1'); });";
    // this.instance.appendChild(s);
    if(isMobile) {
      redirectPlayStore(this.props.match.params.Id);
    }

  }
  videoEnded = () => {
    this.setState({
      videoEndedStatus: "Play Now",
    });
  };
  videoPause = () => {
    this.setState({
      videoEndedStatus: "Play Now",
    });
  };
  videoPlay = () => {
    this.setState({
      videoEndedStatus: "Pause Now",
    });
  };
  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  eventComscore = (genre) => {
    // if (window.self.COMSCORE) {
    //   console.log("comscore event");
    //   window.COMSCORE.beacon({
    //     c1: "2",
    //     c2: "7947673",
    //     c4: window.location.href,
    //     c5: genre,
    //   });
    // }
  };

  componentDidUpdate(prevProps) {
    //console.log(sessionStorage.getItem("Logged-in"));
    if (prevProps.match.params.Id !== this.props.match.params.Id) {
      this._fetchDetails();
    }
    // if (prevProps.match.params.Id !== this.props.match.params.Id && this.props.match.params.Id!=="122165" && this.props.match.params.Id!=="122164") {
    //     this._fetchDetails();
    // }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  appLanguageStings = () => {
    myplexAPI.getDetailPageAppLangStings().then((res) => {
      // console.log(res)
      if (res.data.status === "SUCCESS") {
        this.setState({
          detailLangList: res.data.language_strings,
        });
      }
    });
  };
  _fetchDetails = () => {
    let contentId = this.props.match.params.Id;
    // let params = queryStringParse(this.props.location.search);
    // const video_type = params.videotype;
    // if (video_type === "program") {
    var arr = contentId.split("_");
    contentId = arr[0];
    // }
    //const glbl_state = this;
    var videoId,
      is_Live,
      youtubeId,
      is_youtube,
      is_TVShow,
      similarContent,
      is_tvepisode,
      Hungama,
      synopses_description,
      isTrailerExisted,
      seriesId,
      seriestags;
    let meta_title = "vodafone-play";
    let classname = "flow_player";
    const menu = this.props.match.params.PageName;
    localStorage.setItem("menu", menu);
    myplexAPI.getContentData(contentId).then((response) => {
      var contentTitle;
      var genre;
      var language;
      var actor;
      var actress;
      var episodeTitle;
      var release_Year;
      var networkName;
      var channelName;
      var channelLanguage;

      var duration;
      var actornames = [];
      var data = {};
      var country_Code;
      var months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      if (response.data.status === "SUCCESS") {
        if (response.data.results.length === 0) {
          try {
            this.props.history.push("/" + this.props.match.params.PageName);
          } catch (e) {
            // console.log(e);
          }
        }
        if (this._isMounted) {
          if (response.data.results.length > 0) {
            let genreValue = "";
            // console.log("response",response)
            if (response.data.results[0].content.genre.length > 0) {
              genreValue = response.data.results[0].content.genre[0].name;
              this.eventComscore(genreValue);
            } else {
              genreValue = "";
              this.eventComscore(genreValue);
            }
            var languageValue = "";
            if (response.data.results[0].generalInfo.type === "tvseason") {
              contentId =
                response.data.results[0].globalServiceId ||
                response.data.results[0]._id;
            }
            if (response.data.results[0].generalInfo.type === "tvepisode") {
              is_tvepisode = true;
            }
            // if (response.data.results[0].generalInfo.type === "news") {
            //   document.body.classList.remove("dark-theme");
            //   document.body.classList.add("white-theme");
            // }
            if (response.data.results[0].relatedMultimedia.values.length > 0) {
              // console.log(response.data.results[0].relatedMultimedia.values,'myddd')
              isTrailerExisted = true;
            }

            var GGID =
              response.data.results[0].globalServiceId ||
              response.data.results[0]._id;
            // console.log("Details", response);
            // console.log("tes",response.data.results[0].generalInfo.type);

            myplexAPI.getContentData(GGID).then((res) => {
              // console.log("GGID",res)
              if (res.data.results.length > 0) {
                this.studioname =
                  res.data.results[0].publishingHouse.publishingHouseName;
                if (
                  res.data.results[0].generalInfo.showDisplayTabs.length > 0
                ) {
                  this.setState({
                    showDisplayTabs:
                      res.data.results[0].generalInfo.showDisplayTabs,
                  });
                }
                if (is_tvepisode) {
                  seriesId = res.data.results[0].globalServiceId;
                  seriestags = res.data.results[0].tags;
                }
                if (res.data.results[0].generalInfo.title) {
                  this.setState({
                    contentTitle: res.data.results[0].generalInfo.title,
                  });
                }
                if (res.data.results[0].generalInfo.description) {
                  // console.log(res.data.results[0].generalInfo.description);
                  this.setState({
                    contentDescription:
                      res.data.results[0].generalInfo.description,
                  });
                }
                if (res.data.results[0].content.language.length > 0) {
                  languageValue = res.data.results[0].content.language[0];
                }

                // console.log(res);
                let contentGenre = res.data.results[0].content.genre
                  .map((gen, i) => {
                    return gen.name;
                  })
                  .toString();

                var contentDetData = {
                  "content name": res.data.results[0].generalInfo.title,
                  "content type": res.data.results[0].generalInfo.type,
                  "content id": res.data.results[0].generalInfo._id,
                  "content duration": res.data.results[0].content.duration,
                  "content language": languageValue,
                  "content genre": contentGenre,
                  "content position": this.contentPosition,
                  "carousel position": this.carouselPosition,
                  "content model":
                    res.data.results[0].generalInfo.isSellable === true
                      ? "Paid"
                      : "Free",
                  source: localStorage.getItem("source"),
                  source_detail: localStorage.getItem("source details"),
                  "release date": res.data.results[0].content.releaseDate,
                };
                // firebaseEvents.contenDetViewed(contentDetData);

                if (sessionStorage.getItem("promobanner")) {
                  sessionStorage.removeItem("promobanner");

                  lensEvents.promoVideoShowed(
                    res.data.results[0],
                    this.contentPosition,
                    this.carouselPosition,
                    this.tabName,
                    this.contentSource,
                    this.sourceName
                  );
                }
                if (response.data.results[0].generalInfo.type == "tvepisode") {
                  this.sourceName = `${response.data.results[0].globalServiceName} | ${response.data.results[0].content.siblingOrder}`;
                }
                lensEvents.contentDetailsViewed(
                  res.data.results[0],
                  this.contentPosition,
                  this.carouselPosition,
                  this.tabName,
                  this.contentSource,
                  this.sourceName,
                  this.studioname
                );
              }
              //     if()
              // var Season_ID =
              const video_type = response.data.results[0].generalInfo.type;
              const canonicalURL =
                response.data.results[0].generalInfo.canonicalURL;
              if (canonicalURL !== "") {
                this.setState({
                  og_url: canonicalURL,
                });
              }
              if (
                process.env.REACT_APP_CONFIGARATION === "vodafone" &&
                response.data.results[0].generalInfo.synopsis !== ""
              ) {
                this.setState({
                  alt_description: true,
                });
              }
              // if (process.env.REACT_APP_CONFIGARATION === "idea" && response.data.results[0].generalInfo.altSynopsis !== "") {
              //     this.setState({
              //         alt_description: true
              //     })
              // }
              if (
                response.data.results[0]._id !== null ||
                response.data.results[0]._id !== undefined
              ) {
                this.setState({
                  _contentId: response.data.results[0]._id,
                });
              }
              if (
                response.data.results[0].content.releaseDate !== null ||
                response.data.results[0].content.releaseDate !== undefined
              ) {
                this.setState({
                  _releasedDate: response.data.results[0].content.releaseDate,
                });
              }
              if (
                response.data.results[0].content.createdDate !== "" ||
                response.data.results[0].content.createdDate !== null ||
                response.data.results[0].content.createdDate !== undefined
              ) {
                this.setState({
                  _createdDate: response.data.results[0].content.createdDate,
                });
              }

              if (response.data.results[0].images && response.data.results[0].images.values && response.data.results[0].images.values.length > 0) {
                let imgURL =
                  response.data.results[0].images.values &&
                  response.data.results[0].images.values.find &&
                  response.data.results[0].images.values.find(
                    (i) => i.profile === "hdpi" && i.type === "coverposter"
                  );
                this.setState({
                  _contentThumbnail: imgURL && imgURL.link,
                });
              }
              if (response.data.results[0].videos.status === "SUCCESS") {
                if (response.data.results[0].videos.values && response.data.results[0].videos.values.length > 0) {
                  this.setState({
                    _contentUrl: response.data.results[0].videos.values[0].link,
                  });
                }
              }
              if (
                response.data.results[0].generalInfo.description !== null ||
                response.data.results[0].generalInfo.description !== undefined
              ) {
                let description =
                  response.data.results[0].generalInfo.description.replace(
                    /['"]+/g,
                    ""
                  );
                if (
                  process.env.REACT_APP_CONFIGARATION === "vodafone" &&
                  response.data.results[0].generalInfo.synopsis !== ""
                ) {
                  description = response.data.results[0].generalInfo.synopsis;
                }
                // if (process.env.REACT_APP_CONFIGARATION === "idea" && response.data.results[0].generalInfo.altSynopsis !== "") {
                //     description = response.data.results[0].generalInfo.altSynopsis;
                // }
                // description = description.replace(/['"]+/g, '');
                this.setState({
                  description: description,
                });
              }
              if (
                response.data.results[0].content.duration !== "" ||
                response.data.results[0].content.duration !== null ||
                response.data.results[0].content.duration !== undefined
              ) {
                this.setState({
                  _liveDuration: this._convertDurationFormat(
                    response.data.results[0].content.duration
                  ),
                });
              }
              if (
                response.data.results[0].content.startDate !== "" ||
                response.data.results[0].content.startDate !== null ||
                response.data.results[0].content.startDate !== undefined
              ) {
                this.setState({
                  _liveStartDate: response.data.results[0].content.startDate,
                });
              }
              if (
                response.data.results[0].content.endDate !== "" ||
                response.data.results[0].content.endDate !== null ||
                response.data.results[0].content.endDate !== undefined
              ) {
                this.setState({
                  _liveEndDate: response.data.results[0].content.endDate,
                });
              }
              // if (video_type === 'news' ||  video_type==='tvseries' ||video_type==='tvepisode' || video_type==='tvseason' ) {
              //     this.setState({  recommened: true })
              // }
              if (video_type === "news") {
                this.setState({ similarNews: true });
                var contentTitle = response.data.results[0].generalInfo.title
                  ? response.data.results[0].generalInfo.title
                  : "";
                this.title_Ref = ` ${contentTitle} - manoramaMAX`;
                this.description_Ref = ` ${contentTitle} `;
              }
              if (video_type === "live") {
                // this.setState({ similarNews: true });
                var contentTitle = response.data.results[0].generalInfo.title
                  ? response.data.results[0].generalInfo.title
                  : "";
                this.title_Ref = ` ${contentTitle} online - manoramaMAX`;
                this.description_Ref = ` ${contentTitle} Online on manoramaMAX. ${response.data.results[0].generalInfo.description}`;
              }

              if (video_type === "youtube") {
                youtubeId = contentId;
                is_youtube = true;
                meta_title = "youtube-videos";
              } else if (video_type === "program" || video_type === "live") {
                videoId = contentId;
                is_Live = true;
                meta_title = "live-tv";
                /** Meta rules*/
                // console.log(response.data.results[0].content)
                if (response.data.results[0].content.genre.length > 0) {
                  if (
                    response.data.results[0].content.genre[0].name === "News"
                  ) {
                    if (
                      response.data.results[0].generalInfo.title === "" ||
                      response.data.results[0].generalInfo.title === null
                    ) {
                      channelName = "";
                    } else {
                      channelName = response.data.results[0].generalInfo.title;
                    }
                    if (
                      response.data.results[0].content.language.length === 0
                    ) {
                      channelLanguage = "";
                    } else {
                      channelLanguage =
                        response.data.results[0].content.language[0];
                    }

                    this.title_Ref =
                      "Watch " +
                      channelName +
                      " for Latest Breaking News in " +
                      channelLanguage +
                      " on ManoramaMAX";
                    this.description_Ref =
                      "Watch " +
                      channelName +
                      " news " +
                      channelLanguage +
                      " live for latest headlines on ManoramaMAX. See " +
                      channelName +
                      " news " +
                      channelLanguage +
                      " live on-the-go for all breaking news.";
                    synopses_description =
                      "Watch " +
                      channelName +
                      " News " +
                      channelLanguage +
                      " Live for breaking news and latest headlines on ManoramaMAX";

                    this.setState({
                      new_Title: this.title_Ref,
                      new_Description: this.description_Ref,
                      synopses_description: synopses_description,
                    });
                  } else if (
                    response.data.results[0].content.genre[0].name ===
                    "Entertainment"
                  ) {
                    if (
                      response.data.results[0].generalInfo.title === "" ||
                      response.data.results[0].generalInfo.title === null
                    ) {
                      channelName = "";
                    } else {
                      channelName = response.data.results[0].generalInfo.title;
                    }
                    if (
                      response.data.results[0].content.language.length === 0
                    ) {
                      channelLanguage = "";
                    } else {
                      channelLanguage =
                        response.data.results[0].content.language[0];
                    }

                    this.title_Ref =
                      "Watch " +
                      channelName +
                      " Live for Latest " +
                      channelLanguage +
                      " Serials Online - ManoramaMAX";
                    this.description_Ref =
                      "Watch " +
                      channelName +
                      " live for " +
                      channelLanguage +
                      " entertainment shows online on ManoramaMAX. Stream your favourite " +
                      channelLanguage +
                      " serials live  in HD on " +
                      channelName;
                    synopses_description =
                      "Watch " +
                      channelName +
                      " live " +
                      channelLanguage +
                      " for the most-watched entertainment movies & tv shows in HD only on ManoramaMAX.";

                    if (
                      process.env.REACT_APP_CONFIGARATION === "vodafone" &&
                      response.data.results[0].generalInfo.synopsis !== ""
                    ) {
                      synopses_description =
                        response.data.results[0].generalInfo.synopsis;
                    }
                    if (
                      process.env.REACT_APP_CONFIGARATION === "idea" &&
                      response.data.results[0].generalInfo.altSynopsis !== ""
                    ) {
                      synopses_description =
                        response.data.results[0].generalInfo.altSynopsis;
                    }
                    this.setState({
                      new_Title: this.title_Ref,
                      new_Description: this.description_Ref,
                      synopses_description: synopses_description,
                    });
                  } else if (
                    response.data.results[0].content.genre[0].name === "Music"
                  ) {
                    if (
                      response.data.results[0].generalInfo.title === "" ||
                      response.data.results[0].generalInfo.title === null
                    ) {
                      channelName = "";
                    } else {
                      channelName = response.data.results[0].generalInfo.title;
                    }

                    this.title_Ref = `Stream & Enjoy ${channelName} Music Channel Live  on ManoramaMAX.`;
                    this.description_Ref = `Watch ${channelName} music channel live in HD. Stream ${channelName} live music channel online for your favourite music genres & songs online in HD on ManoramaMAX website.`;
                    // synopses_description = 'Watch ' + channelName + ' live ' + channelLanguage + ' for the most-watched entertainment movies & tv shows for Free in HD only on Vodafone Play.'

                    this.setState({
                      new_Title: this.title_Ref,
                      new_Description: this.description_Ref,
                      synopses_description: synopses_description,
                    });
                  }
                }
              } else if (
                video_type === "tvseries" ||
                video_type === "vodchannel" ||
                video_type === "tvseason"
              ) {
                is_TVShow = true;
                meta_title = "tv-series";
                // console.log(this.props.episodesParams.PageName)

                /** */

                if (response.data.results[0].content.language.length === 0) {
                  language = "";
                } else {
                  language = response.data.results[0].content.language[0];
                }
                if (
                  response.data.results[0].generalInfo.title === "" ||
                  response.data.results[0].generalInfo.title === null
                ) {
                  contentTitle = "";
                } else {
                  contentTitle = response.data.results[0].generalInfo.title;
                }
                if (response.data.results[0].content.genre.length === 0) {
                  genre = "";
                } else {
                  genre = response.data.results[0].content.genre[0].name;
                }
                if (
                  response.data.results[0].publishingHouse
                    .publishingHouseName === "" ||
                  response.data.results[0].publishingHouse
                    .publishingHouseName === null
                ) {
                  networkName = "";
                } else {
                  networkName =
                    response.data.results[0].publishingHouse
                      .publishingHouseName;
                }
                if (response.data.results[0].relatedCast.values.length === 0) {
                  actor = "Not Available";
                  actress = "Not Available";
                } else {
                  // eslint-disable-next-line
                  {
                    response.data.results[0].relatedCast.values[0]
                      ? (actor =
                          response.data.results[0].relatedCast.values[0].name)
                      : (actor = "Not Available");
                  }
                  // eslint-disable-next-line
                  {
                    response.data.results[0].relatedCast.values[1]
                      ? (actress =
                          response.data.results[0].relatedCast.values[1].name)
                      : (actress = "Not Available");
                  }
                }

                if (
                  response.data.results[0].content.duration === "" ||
                  response.data.results[0].content.duration === null
                ) {
                  duration = "";
                } else {
                  duration = response.data.results[0].content.duration;
                }
                const release_date =
                  response.data.results[0].content.releaseDate;

                if (this.props.match.params.PageName === "tvshows") {
                  this.title_Ref =
                    "Watch " +
                    contentTitle +
                    " TV Show full episodes online in  ManoramaMAX.";
                  this.description_Ref =
                    "Watch " +
                    contentTitle +
                    " TV show full episodes online on ManoramaMAX, for your daily dose of " +
                    language +
                    " " +
                    genre +
                    " show. Enjoy " +
                    contentTitle +
                    " latest episodes in HD.";
                  synopses_description =
                    "Watch " +
                    contentTitle +
                    " full episodes online, a captivating " +
                    genre +
                    " TV show on ManoramaMAX.";
                }

                if (this.props.match.params.PageName === "originals") {
                  this.title_Ref = `Watch Full episodes ${contentTitle}  Online , a ${language} Web Series in HD on ManoramaMAX.`;
                  this.description_Ref = `Watch full episodes of ${contentTitle} in HD on ManoramaMAX, for this ${language} ${genre} web series. Catch ${contentTitle} full episode online on your one-stop-shop for entertainment.`;
                  synopses_description = `Watch ${contentTitle} web series full episodes, an enthralling ${language} original in HD on ManoramaMAX.`;
                }

                data = {
                  title: contentTitle,
                  language: language,
                  url: window.location,
                  releaseYear:
                    new Date(release_date).getFullYear() +
                    "-" +
                    (new Date(release_date).getMonth() + 1) +
                    "-" +
                    new Date(release_date).getDate(),
                  actor: actor,
                  actress: actress,
                  countryCode: country_Code,
                  duration: this._convertDurationFormat(duration),
                };
                this.setState({
                  movieMarkup: data,
                });
              } else if (video_type === "tvepisode") {
                // is_TVShow = true;
                // console.log(response)

                // console.log(this.props.match.params.PageName)
                videoId = contentId;
                is_tvepisode = true;
                meta_title = "tv-episode";
                /** */

                if (
                  response.data.results[0].title === "" ||
                  response.data.results[0].title === null
                ) {
                  episodeTitle = "";
                } else {
                  episodeTitle = response.data.results[0].title;
                }
                if (response.data.results[0].content.language.length === 0) {
                  language = "";
                } else {
                  language = response.data.results[0].content.language[0];
                }
                if (
                  response.data.results[0].generalInfo.title === "" ||
                  response.data.results[0].generalInfo.title === null
                ) {
                  contentTitle = "";
                } else {
                  contentTitle = response.data.results[0].globalServiceName;
                }
                if (response.data.results[0].content.genre.length === 0) {
                  genre = "";
                } else {
                  genre = response.data.results[0].content.genre[0].name;
                }
                if (
                  response.data.results[0].publishingHouse
                    .publishingHouseName === "" ||
                  response.data.results[0].publishingHouse
                    .publishingHouseName === null
                ) {
                  networkName = "";
                } else {
                  networkName =
                    response.data.results[0].publishingHouse
                      .publishingHouseName;
                }
                if (response.data.results[0].relatedCast.values.length === 0) {
                  actor = "Not Available";
                  actress = "Not Available";
                } else {
                  // eslint-disable-next-line
                  {
                    response.data.results[0].relatedCast.values[0]
                      ? (actor =
                          response.data.results[0].relatedCast.values[0].name)
                      : (actor = "Not Available");
                  }
                  // eslint-disable-next-line
                  {
                    response.data.results[0].relatedCast.values[1]
                      ? (actress =
                          response.data.results[0].relatedCast.values[1].name)
                      : (actress = "Not Available");
                  }
                }
                // if (response.data.results[0].videos.values.length > 0) {

                //     country_Code = response.data.results[0].videos.allowedCountries[0]

                // }
                if (
                  response.data.results[0].content.duration === "" ||
                  response.data.results[0].content.duration === null
                ) {
                  duration = "";
                } else {
                  duration = response.data.results[0].content.duration;
                }
                response.data.results[0].relatedCast.values.map((value, i) => {
                  if (value.types[0] === "Director") {
                    this.setState({
                      director: value.name,
                    });
                  }
                  return i;
                });
                const episode = response.data.results[0].content.serialNo;
                const release_date =
                  response.data.results[0].content.releaseDate;
                this.title_Ref = `Watch ${contentTitle} Serial - Episode ${response.data.results[0].content.siblingOrder}`;
                this.description_Ref = `Watch ${contentTitle} Serial - Episode ${response.data.results[0].content.siblingOrder} only on manoramaMAX`;

                if (this.props.match.params.PageName === "tvshows") {
                  this.title_Ref =
                    "Watch Episode " +
                    episode +
                    " Full Episode of " +
                    contentTitle +
                    " Online - manoramaMAX";
                  this.description_Ref =
                    "Watch Episode " +
                    episode +
                    " Full Episode of " +
                    contentTitle +
                    " Online on ManoramaMAX. Enjoy " +
                    contentTitle +
                    " Episode " +
                    episode +
                    " telecast on " +
                    new Date(release_date).getDate() +
                    " " +
                    months[new Date(release_date).getMonth()] +
                    " " +
                    new Date(release_date).getFullYear() +
                    " in HD.";
                  this.getSeasonNO(
                    response.data.results[0].globalServiceId
                  ).then((res) => {
                    if (response.data.results[0].generalInfo.synopsis === "") {
                      this.setState({
                        synopses_description:
                          "Watch " +
                          contentTitle +
                          " season " +
                          res +
                          " episode " +
                          episode +
                          ", for latest updates on ManoramaMAX.",
                        flag: "false",
                      });
                    }
                  });
                }
                if (this.props.match.params.PageName === "originals") {
                  this.title_Ref = `Watch ${contentTitle}  Episode ${episode} Full Episode Online  on ManoramaMAX`;
                  this.description_Ref = `Watch ${contentTitle}  Episode ${episode} - ${episodeTitle} Full Episode in HD on ManoramaMAX. Enjoy ${contentTitle}  ${language} originals Episode ${episode} online.`;
                  synopses_description = `Watch ${episodeTitle} for all latest occurences from episode ${episode} of ${contentTitle}  on ManoramaMAX.`;
                }

                data = {
                  title: contentTitle,
                  language: language,
                  url: window.location,
                  releaseYear:
                    new Date(release_date).getFullYear() +
                    "-" +
                    (new Date(release_date).getMonth() + 1) +
                    "-" +
                    new Date(release_date).getDate(),
                  actor: actor,
                  actress: actress,
                  countryCode: country_Code,
                  duration: this._convertDurationFormat(duration),
                  director: this.state.director,
                };
                this.setState({
                  movieMarkup: data,
                });
              } 
              // else if (video_type === "musicvideo") {
              //   // var contentTitle = response.data.results[0].generalInfo.title ? response.data.results[0].generalInfo.title : "" ;
              //   //   this.title_Ref=`Listen to ${contentTitle} - manoramaMAX`;
              //   //   this.description_Ref=`Listen to ${contentTitle}` ;
              //     // console.log("descrption-ref", this.description_Ref)
              // }
              else if (video_type === "movie") {
                similarContent = true;
                videoId = contentId;
                meta_title = "movies";
                /* new code*/
                if (response.data.results[0].content.genre.length === 0) {
                  genre = "";
                } else {
                  // genre = response.data.results[0].content.genre[0].name;
                  genre = this.getGenre(response.data.results[0].content.genre);
                }
                if (response.data.results[0].content.language.length === 0) {
                  language = "";
                } else {
                  language = response.data.results[0].content.language[0];
                }
                if (response.data.results[0].relatedCast.values.length === 0) {
                  actor = "Not Available";
                  actress = "Not Available";
                } else {
                  // eslint-disable-next-line
                  {
                    response.data.results[0].relatedCast.values[0]
                      ? (actor =
                          response.data.results[0].relatedCast.values[0].name)
                      : (actor = "Not Available");
                  }
                  // eslint-disable-next-line
                  {
                    response.data.results[0].relatedCast.values[1]
                      ? (actress =
                          response.data.results[0].relatedCast.values[1].name)
                      : (actress = "Not Available");
                  }
                  response.data.results[0].relatedCast.values.map(
                    (value, i) => {
                      if (value.types[0] === "Director") {
                        this.setState({
                          director: value.name,
                        });
                      }
                      actornames.push(`"${value.name}"`);
                      return i;
                    }
                  );
                }
                if (
                  response.data.results[0].publishingHouse
                    .publishingHouseName === "" ||
                  response.data.results[0].publishingHouse
                    .publishingHouseName === null
                ) {
                  networkName = "";
                } else {
                  networkName =
                    response.data.results[0].publishingHouse
                      .publishingHouseName;
                }

                if (
                  response.data.results[0].content.releaseDate === "" ||
                  response.data.results[0].content.releaseDate === null
                ) {
                  release_Year = "";
                } else {
                  var x = new Date(
                    response.data.results[0].content.releaseDate
                  );
                  release_Year = x.getFullYear();
                }
                if (
                  response.data.results[0].generalInfo.title === "" ||
                  response.data.results[0].generalInfo.title === null
                ) {
                  contentTitle = "";
                } else {
                  contentTitle = response.data.results[0].generalInfo.title;
                }
                if (
                  response.data.results[0].content.duration === "" ||
                  response.data.results[0].content.duration === null
                ) {
                  duration = "";
                } else {
                  duration = response.data.results[0].content.duration;
                }

                this.title_Ref = `Watch ${contentTitle} Movie: ${language} ${genre} - manoramaMAX`;
                this.description_Ref = `Watch ${contentTitle} Movie: ${language} ${genre}`;

                data = {
                  title: contentTitle,
                  language: language,
                  releaseYear:
                    new Date(x).getDate() +
                    " " +
                    months[new Date(x).getMonth()] +
                    " " +
                    new Date(x).getFullYear(),
                  director: this.state.director,
                  actorNames: actornames,
                  duration: this._convertDurationFormat(duration),
                  image: this.state._contentThumbnail,
                  production_company: networkName,
                };
                this.setState({
                  movieMarkup: data,
                });
              }  
              else if (video_type === "musicvideo") {
                  var contentTitle = response.data.results[0].generalInfo.title ? response.data.results[0].generalInfo.title : "" ;
                    this.title_Ref=`Listen to ${contentTitle} - manoramaMAX`;
                    this.description_Ref=`Listen to ${contentTitle}` ;
                    // console.log("descrption-ref", this.description_Ref)
                    videoId = contentId;
                }
              
              else {
                videoId = contentId;
              }

              const meta_description = this.description_Ref.replace(
                /['"]+/g,
                ""
              );

              var keywords =
                response.data.results[0] &&
                response.data.results[0].tags &&
                response.data.results[0].tags.values &&
                response.data.results[0].tags.values.length > 0 &&
                genres(response.data.results[0].tags.values);
              // if (
              //   process.env.REACT_APP_CONFIGARATION === "vodafone" &&
              //   response.data.results[0].generalInfo.synopsis !== ""
              // ) {
              //   synopses_description =
              //     response.data.results[0].generalInfo.synopsis;
              //   this.description_Ref =
              //     response.data.results[0].generalInfo.synopsis;
              //   // this.description_Ref = this.description_Ref.replace(/['"]+/g, '');
              // }
              // if (
              //   process.env.REACT_APP_CONFIGARATION === "idea" &&
              //   response.data.results[0].generalInfo.altSynopsis !== ""
              // ) {
              //   synopses_description =
              //     response.data.results[0].generalInfo.altSynopsis;
              //   this.description_Ref =
              //     response.data.results[0].generalInfo.altSynopsis;
              //   // this.description_Ref = this.description_Ref.replace(/['"]+/g, '');
              // }
              // console.log("hh",this.description_Ref);
              this.setState({
                contentinfo: response.data.results,
                contentId: contentId,
                videoId: videoId,
                similarContent: similarContent,
                is_TVShow: is_TVShow,
                is_Live: is_Live,
                is_youtube: is_youtube,
                youtubeId: youtubeId,
                is_tvepisode: is_tvepisode,
                Hungama: Hungama,
                meta_title: meta_title,
                classname: classname,
                new_Title: this.title_Ref,
                new_Description: this.description_Ref,
                synopses_description: synopses_description,
                meta_description: meta_description,
                isTrailerExisted: isTrailerExisted,
                seriesId: seriesId,
                seriestags: seriestags,
                keywords: keywords,
              });
            });
          }
          // setTimeout(function() {
          //   glbl_state.setState({ showLoader: false });
          // }, 500);
        }
      }
      // else if (response.data.results.length === 0) {
      //   try {
      //     this.props.history.push("/" + this.props.match.params.PageName);
      //   } catch (e) {
      //     console.log(e);
      //   }
      // }
      else if (response.data.status === "ERR_INTERNAL_SERVER_ERROR") {
        this.setState({
          error: true,
          popUp: true,
          toastMessage: response.data.message,
        });
      }
    });
  };
  getGenre = (generes) => {
    return generes.map(function (genere, i) {
      return genere.name;
    });
  };
  closePopUp = () => {
    this.setState({
      popUp: false,
    });
  };
  setVideoID = (ID) => {
    // console.log("seting", ID);
    this.setState({
      videoId: ID,
    });
  };
  _setContentInfo = (data) => {
    this.setState({
      contentinfo: data,
    });
  };
  _callBackTvShow = (data) => {
    this.setState({ episodedata: data });
  };
  getSeasonNO = (Id) => {
    return new Promise((resolve) => {
      myplexAPI.getContentData(Id).then((response) => {
        // console.log(response)
        // console.log(response, "sibling order");
        this.setState({
          tvShowDetails: response.data.results,
        });
        resolve(response.data.results[0].content.siblingOrder);
        //return '1';
      });
    });

    // return resolve(Seasonno);
  };
  _convertDurationFormat = (value) => {
    // PT2H1M33S
    var temp = [];
    if (value !== null || value !== undefined || value !== "") {
      temp = value.split(":");
      // console.log('PT'+temp[0]+'H'+temp[1]+'M'+temp[2]+'S')

      return (
        "PT" +
        ("0" + temp[0]).slice(-2) +
        "H" +
        ("0" + temp[1]).slice(-2) +
        "M" +
        ("0" + temp[2]).slice(-2) +
        "S"
      );

      // if(temp[0] !== '0' && temp[1] !== '00'){
      //     return "PT"+temp[0]+'H'+temp[1]+'M';
      // }else if(temp[0] !== '0' && temp[1] === '00'){
      //     return "PT"+temp[0]+'H';
      // }else if(temp[0] === '0' && temp[1] !== '00'){
      //     return "PT"+temp[1]+'M';
      // }
    }
  };
  getLink = (value) => {
    if (value === "tvshows" || value === "tv") {
      value = "TV";
    }

    return value;
  };

  render() {
    // console.log(this.state.videoId);
    let title,
      season,
      episode = "";
    let navMenu = window.location.pathname.split("/")[1];
    const content_info = this.state.contentinfo;
    const tvShowDetails = this.state.tvShowDetails;
    if (content_info.length > 0) {
      title = (
        <Link to={window.location.pathname}>
          {content_info[0].generalInfo.title}
        </Link>
      );

      if (
        content_info[0].globalServiceName !== null &&
        tvShowDetails.length > 0
      ) {
        title = content_info[0].generalInfo.title.split("|");
        season = title[0];
        episode = title[1];
        // console.log(title)
        title = (
          <>
            <Link
              to={{
                pathname: `/${this.props.match.params.PageName}/${tvShowDetails[0]._id}/${this.props.match.params.Url}/season${tvShowDetails[0].content.siblingOrder}/episodes`,
              }}
            >
              {season}
            </Link>{" "}
            <Link to={window.location.pathname}>|{episode} </Link>{" "}
          </>
        );
        // title =+ title
      }
    }
    if (navMenu === "tvshows") {
      navMenu = "TV Shows";
    }
    // console.log(this.state.detailLangList)
    let you_may_like_title = "People also watched";
    let currently_playing_on_other_channels =
      "Currently Playing on other channels";
    let upcoming_programs = "Upcoming Programs";
    let episodes_title = "Episodes";
    let seasons_title = "Seasons";
    let season_title = "Season";
    let trending_tv_shows = "Trending TV Shows";
    if (this.state.detailLangList !== "" && this.state.appLanguage !== null) {
      you_may_like_title = langBasedPrograms(
        this.state.detailLangList,
        you_may_like_title
      );
      currently_playing_on_other_channels = langBasedPrograms(
        this.state.detailLangList,
        currently_playing_on_other_channels
      );
      upcoming_programs = langBasedPrograms(
        this.state.detailLangList,
        upcoming_programs
      );
      episodes_title = langBasedPrograms(
        this.state.detailLangList,
        episodes_title
      );
      seasons_title = langBasedPrograms(
        this.state.detailLangList,
        seasons_title
      );
      season_title = langBasedPrograms(this.state.detailLangList, season_title);
      trending_tv_shows = langBasedPrograms(
        this.state.detailLangList,
        trending_tv_shows
      );
    }

    return (
      <div>
        <div className="player">
          <section className="player_section topheader_banner">
            <div className={this.state.classname}>
              {this.state.contentinfo.length > 0 && (
                <SEO
                  _id={this.state._contentId}
                  title={this.state.meta_title}
                  meta_description={this.state.meta_description}
                  // og_description={
                  //   this.state.contentinfo[0].generalInfo.description
                  // }
                  og_description={
                    this.state.contentinfo[0].generalInfo.type == "tvepisode" ||
                    this.state.contentinfo[0].generalInfo.type == "musicvideo"
                      ? this.state.new_Description
                      : this.state.contentinfo[0].generalInfo.description
                  }
                  // og_title={this.state.contentinfo[0].generalInfo.title}
                  og_title={this.state.new_Title}
                  image={this.state.contentinfo[0].images}
                  URL={this.props.match.params.Id}
                  type={this.state.contentinfo[0].generalInfo.type}
                  new_og_title={this.state.new_Title}
                  new_og_description={this.state.new_Description}
                  content_Details = {this.state.contentinfo}
                  contentUrl={this.state._contentUrl}
                  thumbnailUrl={this.state._contentThumbnail}
                  releaseYear={this.state._releasedDate}
                  createdDate={this.state._createdDate}
                  _description={this.state.description}
                  movieMarkupDetails={this.state.movieMarkup}
                  liveStartDate={this.state._liveStartDate}
                  liveEndDate={this.state._liveEndDate}
                  _liveDuration={this.state._liveDuration}
                  episodeNumber={this.state.contentinfo[0].content.serialNo}
                  og_url={this.state.og_url}
                  keywords={this.state.keywords}
                />
              )}
              {this.state.is_youtube ? (
                <Youtube
                  videoId={this.state.youtubeId}
                  data={this.state.contentinfo}
                  Auth={this.state.Auth}
                />
              ) : this.state.is_TVShow ? (
                <TvseriesView
                  episodedata={this.state.episodedata}
                  episodesParams={this.props.match.params}
                />
              ) : (
                this.state.videoId && (
                  <div>
                    <PassPlayer
                      videoId={this.state.videoId}
                      Auth={this.state.Auth}
                      callBackTvShow={this._setContentInfo}
                      callBack={this.state.is_TVShow}
                      contentinfo={this.state.contentinfo}
                      videoEnded={this.videoEnded}
                      videoPlay={this.videoPlay}
                      videoPause={this.videoPause}
                    />
                  </div>
                )
              )}
            </div>

            {this.state.contentinfo.length > 0 && this.state.flag && (
              <Bcncontentinfo
                info={this.state.contentinfo[0]}
                Auth={this.state.Auth}
                synopses_description={this.state.synopses_description}
                flag={this.state.flag}
                alt_description={this.state.alt_description}
                episodeButton={this.state.is_TVShow}
                episodedata={this.state.episodedata}
                videoEndedStatus={this.state.videoEndedStatus}
                episodesParams={this.props.match.params}
              />
            )}
          </section>
          <div>
          {  this.state.contentinfo.length > 0 &&
            <Adunit  contentinfo={this.state.contentinfo}/> }
        </div>

          {/* <div className="breadcrumb_section"></div> */}

          {
            // !isMobile && (
            //   <div className="detail_description_section">
            //     {/* <div className="movie_details_text">
            //                     {this.state.contentinfo.length > 0 && <h1 class="movie_details_title">{this.state.contentTitle}</h1>}
            //                 </div> */}
            //     <div className="epi_description">
            //       f
            //         <p>{ this.state.contentinfo[0].generalInfo.description!=="NA" && this.state.contentinfo[0].generalInfo.description}</p>
            //       )}
            //     </div>
            //   </div>
            // )
          }

          {!isMobile &&
            this.state.contentinfo.length > 0 &&
            this.state.flag &&
            this.state.contentinfo[0].relatedCast &&
            this.state.contentinfo[0].relatedCast.values.length > 0 &&
            this.state.contentinfo[0].generalInfo.type === "movie" && (
              <LayoutCastandCrew
                info={this.state.contentinfo[0]}
              ></LayoutCastandCrew>
            )}

          {this.state.is_Live && this.state.contentinfo.length > 0 && (
            <Epg
              ContentId={this.state.videoId}
              data={this.state.contentinfo[0]}
              currently_playing_on_other_channels={
                currently_playing_on_other_channels
              }
              upcoming_programs={upcoming_programs}
            />
          )}
          {/* {this.state.contentId !== null && (this.state.is_TVShow || this.state.is_tvepisode) && ( */}
          {this.state.contentId !== null &&
            (this.state.showDisplayTabs.length > 0 ||
              this.state.is_TVShow ||
              this.state.is_tvepisode) && (
              <Episodes
                ContentId={this.state.contentId}
                setVideoID={this.setVideoID}
                info={this.state.contentinfo[0]}
                tvepisode={this.state.is_tvepisode}
                callBackTvShow={this._callBackTvShow}
                episodesParams={this.props.match.params}
                episodes_title={episodes_title}
                seasons_title={seasons_title}
                season_title={season_title}
                trending_tv_shows={trending_tv_shows}
                showDisplayTabs={this.state.showDisplayTabs}
                seriesId={this.state.seriesId}
              />
            )}
       


          {/* <section>
            <div className="you-may-like_section">
                {this.state.similarContent && (
                    <YOUMAYLIKE ContentId={this.state.videoId} you_may_like_title={you_may_like_title} />
                )}
            </div>
                    </section> */}

          {this.state.isTrailerExisted && (
            <LayoutTrailersCarousel
              trailersData={this.state.contentinfo[0].relatedMultimedia.values}
            />
          )}
          {}
          {this.state.contentinfo[0] && this.state.contentinfo[0].generalInfo.type=="movie" ?
           <MovieCarosuls
              info={this.state.contentinfo[0]}
              ContentId={this.state.videoId}
              tvepisode={this.state.is_tvepisode}
              seriestags={this.state.seriestags}
            /> :
          this.state.recommened ? (
            <Recommended
              info={this.state.contentinfo[0]}
              ContentId={this.state.videoId}
              tvepisode={this.state.is_tvepisode}
              seriestags={this.state.seriestags}
              type={"contentlist"} 
               MyrecoData = {null}
               carosulcount = {1}
            /> ) : null }
          
          {/* {!isMobile && this.state.similarNews && <LayoutSimilarNewsCarousel ContentId={this.state.videoId} carosuelName='' />} */}
          {this.state.showLoader && <Loader />}
          {this.state.error && (
            <Modalview
              modalshow={this.state.popUp}
              modalonHide={this.closePopUp}
              toastMessage={this.state.toastMessage}
            />
          )}
        </div>
      </div>
    );
  }
}
